import { Link } from 'react-router-dom'
import { useSession } from '@/features/auth/use-auth'

/**
 * The month's AI budget is spent. Said up front, next to a disabled button,
 * rather than after a click — and an admin, who can raise the limit, gets the
 * way there.
 */
export function LimitNotice({ message }: { message?: string }) {
  const { user } = useSession()

  return (
    <p className="border-warning/40 bg-warning/10 text-ink border px-3 py-2 text-xs leading-relaxed">
      <span className="font-medium">Monatslimit für KI-Nutzung erreicht.</span>{' '}
      {message && message !== 'Monatslimit für KI-Nutzung erreicht.' ? `${message} ` : ''}
      {user?.role === 'admin' ? (
        <Link to="/settings#ki-nutzung" className="text-brand underline underline-offset-2">
          Einstellungen › KI-Nutzung
        </Link>
      ) : (
        'Neue Briefings sind ab dem nächsten Monat wieder möglich — oder ein Administrator hebt das Limit an.'
      )}
    </p>
  )
}
